import React from 'react';
import { ConstantPermissions } from 'contexts/useConstant';
import Customer from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerSharedFile';

export default function () {
  return (
    <Customer
      cardType="C"
      permissions={{
        store: ConstantPermissions.BASE_BUSINESS_PARTNERS_STORE,
        show: ConstantPermissions.BASE_BUSINESS_PARTNERS_SHOW
      }}
    />
  );
}
